<template>
  <v-dialog v-model="isOpen" :max-width="!hasMenu || hasNotificationConfigAuthority ? 1024 : 480" persistent>
    <v-card>
      <v-card-title primary-title class="primary white--text">
        Criar pasta
      </v-card-title>

      <v-card-text class="pt-6">
        <v-row class="pt-0 mt-0">
          <v-col cols="12">
            <v-text-field label="Novo nome" placeholder="" v-model="newName"/>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancelCreation">
          Cancelar
        </v-btn>
        <v-btn color="primary" :disabled="(isSendingNotification && (!newName.length || !isNotificationConfigValid)) || (!isSendingNotification && !newName.length)" @click="confirmCreation">
          Criar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { findAllDriveDefaultTemplates, findAllDriveEmailTemplates, findAllProfilesByAppCode } from '@/common/securityserver';
import { getAllUsersWithAccessPermissionByFinancialGroup } from '@/common/driveserver';
import store from '../../common/store';

export default {
  name: 'FolderCreationModal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    hasMenu: false,
    isOpen: false,
    creationConfirmed: false,
    newName: '',
    driveDefaultTemplates: [],
    driveEmailTemplates: [],
    indexesHistory: [],
    isCheckedAllProfiles: false,
    isCheckedAllUsers: true,
    isLoadingContent: false,
    isNotificationConfigValid: false,
    isSendingNotification: false,
    itemParams: null,
    hasNotificationConfigAuthority: false,
    notificationConfig: {
      title: 'Notificação do Drive',
      customEmails: '',
      deliveryChannels: null,
      driveDefaultTemplateId: null,
      driveEmailTemplateId: null,
      userIds: null,
      profileIds: null,
      selectedProfiles: [],
      selectedUsers: [],
      pathFileDir: null,
    },
    profiles: [],
    deliveryChannels: [
      { text: 'Notificação Padrão', value: 'DEFAULT_NOTIFICATION' },
      { text: 'Notificação via E-mail', value: 'EMAIL_NOTIFICATION' },
      { text: 'Notificação Push', value: 'PUSH_NOTIFICATION' },
    ],
    deliveryChannelsSalesforce: [
      { text: 'Notificação via E-mail', value: 'EMAIL_NOTIFICATION' },
    ],
    usersWithAccessPermission: [],
    tab: '',
  }),
  watch: {
    open(newValue) {
      this.isOpen = newValue;
      if (!this.isOpen) {
        this.clearNotificationFields();
      }
    },
    isSendingNotification(newValue) {
      if (newValue && !this.isLoadingContent && this.usersWithAccessPermission.length === 0
        && this.profiles.length === 0) {
        this.loadAllInformations();
      }
    },
  },
  methods: {
    clearNotificationFields() {
      this.isSendingNotification = false;
      this.notificationConfig.title = 'Notificação do Drive';
      this.notificationConfig.deliveryChannels = null;
      this.notificationConfig.driveDefaultTemplateId = null;
      this.notificationConfig.driveEmailTemplateId = null;
      this.notificationConfig.userIds = null;
      this.notificationConfig.profileIds = null;
      this.notificationConfig.selectedProfiles = [];
      this.notificationConfig.selectedUsers = [];
      this.profiles = [];
      this.usersWithAccessPermission = [];
    },
    loadPathDir() {
      const indexesHistory = store.getIndexesHistory();
      if (indexesHistory) {
        this.notificationConfig.pathFileDir = indexesHistory[indexesHistory.length - 1].path;
      }
    },
    verifyNotificationFields() {
      this.loadPathDir();
      if (!this.isEmptyNotificationFields(this.notificationConfig)) {
        this.isNotificationConfigValid = true;
      } else {
        this.isNotificationConfigValid = false;
      }
    },
    isEmptyNotificationFields(notificationConfig) {
      const emptyFields = [];
      if (this.hasMenu && notificationConfig.driveDefaultTemplateId === null) {
        emptyFields.push('Template Padrão');
      }
      if (notificationConfig.driveEmailTemplateId === null) {
        emptyFields.push('Template de E-mail');
      }
      if (this.hasMenu && (!notificationConfig.selectedUsers || (notificationConfig.selectedUsers && notificationConfig.selectedUsers.length === 0
        && (!notificationConfig.selectedProfiles || (notificationConfig.selectedProfiles && notificationConfig.selectedProfiles.length === 0))))) {
        emptyFields.push('Usuários');
      }
      if (!this.hasMenu && this.notificationConfig.customEmails.trim().length === 0) {
        emptyFields.push('E-mails dos Usuários');
      }
      if (!notificationConfig.deliveryChannels || (notificationConfig.deliveryChannels && notificationConfig.deliveryChannels.length === 0)) {
        emptyFields.push('Tipos de Notificações');
      }

      if (emptyFields.length > 0) {
        return true;
      }
      return false;
    },
    cancelCreation() {
      this.isOpen = false;
      this.$emit('close');
    },
    confirmCreation() {
      this.loadUserIdsSelectedsToNotify();
      this.loadProfileIdsSelectedsToNotify();
      const newNotificationConfig = { ...this.notificationConfig };
      this.isOpen = false;
      this.$emit('confirm', { newName: this.newName, notificationConfig: newNotificationConfig });
      this.newName = '';
    },
    async loadDriveDefaultTemplates() {
      await findAllDriveDefaultTemplates(store.getToken())
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.driveDefaultTemplates = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os templates default do drive.', 'error', { timeout: 5000 });
        });
    },
    async loadDriveEmailTemplates() {
      await findAllDriveEmailTemplates(store.getToken())
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.driveEmailTemplates = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os templates email do drive.', 'error', { timeout: 5000 });
        });
    },
    async loadAllProfiles() {
      await findAllProfilesByAppCode(store.getToken())
        .then((response) => {
          if (response.data && response.data.length) {
            this.profiles = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os perfis de usuário.', 'error', { timeout: 5000 });
        });
    },
    async loadUsersWithAccessPermissionByFinancialGroup() {
      const path = this.itemParams && this.itemParams.path ? this.itemParams.path : '';

      await getAllUsersWithAccessPermissionByFinancialGroup(path, store.getToken())
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.usersWithAccessPermission = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os usuários a serem notificados.', 'error', { timeout: 5000 });
        });
    },
    enableAllUsersToNotification() {
      const usersLength = this.usersWithAccessPermission.length;
      for (let count = 0; count < usersLength; count += 1) {
        this.notificationConfig.selectedUsers.push(count);
      }
      this.isCheckedAllUsers = true;
    },
    selectAllProfiles() {
      if (this.isCheckedAllProfiles) {
        this.notificationConfig.selectedProfiles = [];
        this.notificationConfig.selectedProfiles = Array.from(Array(this.profiles.length).keys());
      } else {
        this.notificationConfig.selectedProfiles = [];
      }
      this.verifyNotificationFields();
    },
    selectAllUsers() {
      if (this.isCheckedAllUsers) {
        this.notificationConfig.selectedUsers = [];
        this.notificationConfig.selectedUsers = Array.from(Array(this.usersWithAccessPermission.length).keys());
      } else {
        this.notificationConfig.selectedUsers = [];
      }
      this.verifyNotificationFields();
    },
    loadUserIdsSelectedsToNotify() {
      const usersFiltered = [];
      this.notificationConfig.selectedUsers.forEach((value) => {
        usersFiltered.push(this.usersWithAccessPermission[value].userId);
      });
      this.notificationConfig.selectedUsers = usersFiltered;
    },
    loadProfileIdsSelectedsToNotify() {
      const profilesFiltered = [];
      this.notificationConfig.selectedProfiles.forEach((value) => {
        profilesFiltered.push(this.profiles[value].id);
      });
      this.notificationConfig.selectedProfiles = profilesFiltered;
    },
    verifyHasMenuAndLoadInformations() {
      this.hasMenu = store.getHasMenu();
      this.notificationConfig.isSalesforceConfig = !this.hasMenu;
      this.hasNotificationConfigAuthority = store.getHasNotificationConfigAuthority();
    },
    async loadAllInformations() {
      this.isLoadingContent = true;
      this.verifyHasMenuAndLoadInformations();
      this.loadPathDir();
      await this.loadDriveEmailTemplates();

      if (this.hasMenu) {
        await this.loadDriveDefaultTemplates();
        await this.loadAllProfiles();
        await this.loadUsersWithAccessPermissionByFinancialGroup();
        this.enableAllUsersToNotification();
      }

      this.isLoadingContent = false;
    },
  },
  async created() {
    await this.loadAllInformations();
  },
  beforeMount() {
    this.hasNotificationConfigAuthority = store.getHasNotificationConfigAuthority();
    this.isOpen = this.open;
  },
};
</script>
